import { http } from "@/http";
import { initCsrf } from "@/http/csrf";

export async function loginAdmin(data) {
  await initCsrf();
  return http.post("/admin/login", data);
}

export async function getAdminMe() {
  return http.get("/admin/me");
}

export async function logoutAdmin() {
  return http.post("/admin/logout");
}
